import { render } from "./DesktopCarousellMessageInside.vue?vue&type=template&id=5413dc72&scoped=true"
import script from "./DesktopCarousellMessageInside.vue?vue&type=script&lang=js"
export * from "./DesktopCarousellMessageInside.vue?vue&type=script&lang=js"

import "./DesktopCarousellMessageInside.vue?vue&type=style&index=0&id=5413dc72&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5413dc72"]])

export default __exports__